import _asyncToGenerator from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { env, tidy, util } from '@tensorflow/tfjs-core';
import { getNodeNameAndIndex, getParamValue, getTensor, getTensorsForCurrentContenxt, parseNodeName } from '../operations/executors/utils';
import { executeOp } from '../operations/operation_executor';
import { ExecutionContext } from './execution_context';
import { getExecutionSubgraph, getNodesInTopologicalOrder, isControlFlow } from './model_analysis';
export var GraphExecutor = /*#__PURE__*/function () {
  /**
   *
   * @param graph Graph the model or function graph to be executed.
   * @param parent When building function exector you need to set the parent
   * executor. Since the weights and function executor maps are set at parant
   * level, that function executor can access the function maps and weight maps
   * through the parent.
   */
  function GraphExecutor(graph, parent) {
    var _this = this;
    _classCallCheck(this, GraphExecutor);
    this.graph = graph;
    this.parent = parent;
    this.compiledMap = new Map();
    this._weightMap = {};
    this.SEPERATOR = ',';
    this._functions = {};
    this._functionExecutorMap = {};
    this.intermediateTensors = {};
    this.keepTensorForDebug = false;
    this._outputs = graph.outputs;
    this._inputs = graph.inputs;
    this._initNodes = graph.initNodes;
    this._signature = graph.signature;
    this._functions = graph.functions;
    // create sub-graph executors
    if (graph.functions != null) {
      Object.keys(graph.functions).forEach(function (name) {
        _this._functionExecutorMap[name] = new GraphExecutor(graph.functions[name], _this);
      });
    }
  }
  _createClass(GraphExecutor, [{
    key: "weightIds",
    get: function get() {
      return this.parent ? this.parent.weightIds : this._weightIds;
    }
  }, {
    key: "functionExecutorMap",
    get: function get() {
      return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
  }, {
    key: "weightMap",
    get: function get() {
      return this.parent ? this.parent.weightMap : this._weightMap;
    },
    set: function set(weightMap) {
      var _ref;
      var weightIds = Object.keys(weightMap).map(function (key) {
        return weightMap[key].map(function (tensor) {
          return tensor.id;
        });
      });
      this._weightIds = (_ref = []).concat.apply(_ref, _toConsumableArray(weightIds));
      this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */
  }, {
    key: "resourceManager",
    set: function set(resourceManager) {
      this._resourceManager = resourceManager;
    }
  }, {
    key: "inputs",
    get: function get() {
      return this._inputs.map(function (node) {
        return {
          name: node.name,
          shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
          dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
        };
      });
    }
  }, {
    key: "outputs",
    get: function get() {
      return this._outputs.map(function (node) {
        return {
          name: node.name,
          shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
          dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
        };
      });
    }
  }, {
    key: "inputNodes",
    get: function get() {
      return this._inputs.map(function (node) {
        return node.signatureKey || node.name;
      });
    }
  }, {
    key: "outputNodes",
    get: function get() {
      return this._outputs.map(function (node) {
        var name = node.signatureKey || node.name;
        return node.defaultOutput ? "".concat(name, ":").concat(node.defaultOutput) : name;
      });
    }
  }, {
    key: "functions",
    get: function get() {
      var _this2 = this;
      return Object.keys(this._functions).reduce(function (map, key) {
        map[key] = _this2._functions[key].signature;
        return map;
      }, {});
    }
  }, {
    key: "getCompilationKey",
    value: function getCompilationKey(inputs, outputs) {
      var sortedInputs = inputs.map(function (node) {
        return node.name;
      }).sort();
      var sortedOutputs = outputs.map(function (node) {
        return node.name;
      }).sort();
      return sortedInputs.join(this.SEPERATOR) + '--' + sortedOutputs.join(this.SEPERATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     */
  }, {
    key: "compile",
    value: function compile(inputs, outputs) {
      var executionInfo = getExecutionSubgraph(inputs, outputs, this.weightMap, this._initNodes);
      var missingInputs = executionInfo.missingInputs,
        dynamicNode = executionInfo.dynamicNode,
        syncInputs = executionInfo.syncInputs;
      if (dynamicNode != null) {
        throw new Error("This execution contains the node '".concat(dynamicNode.name, "', which has ") + "the dynamic op '".concat(dynamicNode.op, "'. Please use ") + "model.executeAsync() instead. Alternatively, to avoid the " + "dynamic ops, specify the inputs [".concat(syncInputs, "]"));
      }
      if (missingInputs.length > 0) {
        var outNames = outputs.map(function (n) {
          return n.name;
        });
        var inNames = Object.keys(inputs);
        throw new Error("Cannot compute the outputs [".concat(outNames, "] from the provided inputs ") + "[".concat(inNames, "]. Missing the following inputs: [").concat(missingInputs, "]"));
      }
      return getNodesInTopologicalOrder(this.graph, this.weightMap, executionInfo);
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */
  }, {
    key: "execute",
    value: function execute(inputs, outputs) {
      var _this3 = this;
      inputs = this.mapInputs(inputs);
      var names = Object.keys(inputs).sort();
      this.checkInputs(inputs);
      this.checkInputShapeAndType(inputs);
      outputs = this.mapOutputs(outputs);
      this.checkOutputs(outputs);
      var inputNodes = names.map(function (name) {
        return _this3.graph.nodes[parseNodeName(name)[0]];
      });
      var outputNodeNames = outputs.map(function (name) {
        return parseNodeName(name)[0];
      });
      var outputNodes = outputNodeNames.map(function (name) {
        return _this3.graph.nodes[name];
      });
      this.resetIntermediateTensors();
      // If no outputs are specified, then use the default outputs of the model.
      if (outputNodes.length === 0) {
        outputNodes = this._outputs;
      }
      var compilationKey = this.getCompilationKey(inputNodes, outputNodes);
      // Do nothing if the compiled graph cache contains the input.
      var orderedNodes = this.compiledMap.get(compilationKey);
      if (orderedNodes == null) {
        orderedNodes = this.compile(inputs, outputNodes);
        this.compiledMap.set(compilationKey, orderedNodes);
      }
      var tensorArrayMap = {};
      var tensorListMap = {};
      return tidy(function () {
        var context = new ExecutionContext(_this3.weightMap, tensorArrayMap, tensorListMap, _this3.functionExecutorMap);
        var tensorsMap = Object.assign({}, _this3.weightMap);
        Object.keys(inputs).forEach(function (name) {
          var _parseNodeName = parseNodeName(name),
            _parseNodeName2 = _slicedToArray(_parseNodeName, 2),
            nodeName = _parseNodeName2[0],
            index = _parseNodeName2[1];
          var tensors = [];
          tensors[index] = inputs[name];
          tensorsMap[nodeName] = tensors;
        });
        var tensorsToKeep = _this3.getFrozenTensorIds(tensorsMap);
        var intermediateTensorConsumerCount = {};
        for (var i = 0; i < orderedNodes.length; i++) {
          var node = orderedNodes[i];
          if (!tensorsMap[node.name]) {
            var tensors = executeOp(node, tensorsMap, context, _this3._resourceManager);
            if (util.isPromise(tensors)) {
              throw new Error("The execution of the op '".concat(node.op, "' returned a promise. ") + "Please use model.executeAsync() instead.");
            }
            tensorsMap[node.name] = tensors;
            _this3.checkTensorForDisposal(node.name, node, tensorsMap, context, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount);
          }
        }
        // dispose the context for the root executor
        if (_this3.parent == null) {
          context.dispose(tensorsToKeep);
        }
        return outputs.map(function (name) {
          return getTensor(name, tensorsMap, context);
        });
      });
    }
  }, {
    key: "getFrozenTensorIds",
    value: function getFrozenTensorIds(tensorMap) {
      var ids = [].concat.apply([], Object.keys(tensorMap).map(function (key) {
        return tensorMap[key];
      }).map(function (tensors) {
        return tensors.map(function (tensor) {
          return tensor.id;
        });
      }));
      return new Set(ids);
    }
  }, {
    key: "checkTensorForDisposal",
    value: function checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount) {
      var _this4 = this;
      // Skip output nodes and any control flow nodes, since its dependency is
      // tricky to track correctly.
      if (node.category === 'control' || outputNames.indexOf(nodeName) !== -1) {
        return;
      }
      tensorMap[nodeName].forEach(function (tensor) {
        if (tensor != null) {
          intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        }
      });
      node.inputs.forEach(function (input) {
        // Skip any control flow nodes, since its dependency is tricky to track
        // correctly.
        if (input.category !== 'control') {
          var tensors = getTensorsForCurrentContenxt(input.name, tensorMap, context);
          if (tensors != null) {
            tensors.forEach(function (tensor) {
              if (tensor && !tensor.kept && !tensorsToKeep.has(tensor.id)) {
                var count = intermediateTensorConsumerCount[tensor.id];
                if (count === 1) {
                  if (!_this4.keepTensorForDebug) {
                    tensor.dispose();
                  } else {
                    var _getNodeNameAndIndex = getNodeNameAndIndex(node.name, context),
                      _getNodeNameAndIndex2 = _slicedToArray(_getNodeNameAndIndex, 2),
                      _nodeName = _getNodeNameAndIndex2[0],
                      index = _getNodeNameAndIndex2[1];
                    if (_this4.intermediateTensors[_nodeName]) {
                      _this4.intermediateTensors[_nodeName][index] = tensor;
                    } else {
                      _this4.intermediateTensors[_nodeName] = [];
                      _this4.intermediateTensors[_nodeName][index] = tensor;
                    }
                  }
                  delete intermediateTensorConsumerCount[tensor.id];
                } else if (count != null) {
                  // only intermediate nodes has count set, inputs and weights are
                  // not.
                  intermediateTensorConsumerCount[tensor.id]--;
                }
              }
            });
          }
        }
      });
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */
  }, {
    key: "executeAsync",
    value: function () {
      var _executeAsync2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(inputs, outputs) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this._executeAsync(inputs, outputs));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function executeAsync(_x, _x2) {
        return _executeAsync2.apply(this, arguments);
      }
      return executeAsync;
    }()
  }, {
    key: "disposeIntermediateTensors",
    value: function disposeIntermediateTensors() {
      var _this5 = this;
      if (!this.intermediateTensors) {
        return;
      }
      Object.keys(this.intermediateTensors).forEach(function (key) {
        return _this5.intermediateTensors[key].forEach(function (tensor) {
          return tensor.dispose();
        });
      });
      this.disposeTensorsMap();
    }
  }, {
    key: "disposeTensorsMap",
    value: function disposeTensorsMap() {
      var _this6 = this;
      if (!this.tensorsMap) {
        return;
      }
      Object.keys(this.tensorsMap).forEach(function (key) {
        var tensorArray = _this6.tensorsMap[key];
        tensorArray.forEach(function (tensor) {
          if (tensor && !tensor.kept && !tensor.isDisposed && !_this6.keepIds.has(tensor.id)) {
            tensor.dispose();
          }
        });
      });
    }
  }, {
    key: "getIntermediateTensors",
    value: function getIntermediateTensors() {
      return this.tensorsMap;
    }
  }, {
    key: "resetIntermediateTensors",
    value: function resetIntermediateTensors() {
      for (var key in this.intermediateTensors) {
        this.intermediateTensors[key].forEach(function (tensor) {
          return tensor.dispose();
        });
        delete this.intermediateTensors[key];
      }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optinal global TensorList map by id. Used for
     * function execution.
     */
  }, {
    key: "_executeAsync",
    value: function () {
      var _executeAsync3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(inputs, outputs) {
        var _this7 = this;
        var isFunctionExecution,
          tensorArrayMap,
          tensorListMap,
          context,
          results,
          outputIds,
          inputIds,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isFunctionExecution = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              tensorArrayMap = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
              tensorListMap = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : {};
              if (!isFunctionExecution) {
                inputs = this.mapInputs(inputs);
                this.checkInputs(inputs);
                this.checkInputShapeAndType(inputs);
                outputs = this.mapOutputs(outputs);
                this.checkOutputs(outputs);
              }
              // For model debug.
              try {
                this.keepTensorForDebug = env().getBool('KEEP_INTERMEDIATE_TENSORS');
              } catch (e) {
                console.warn(e.message);
              }
              this.resetIntermediateTensors();
              context = new ExecutionContext(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap); // Graph with control flow op requires runtime evaluation of the execution
              // order, while without control flow the execution order is pre-determined
              // in the compile method.
              _context2.next = 9;
              return this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
            case 9:
              this.tensorsMap = _context2.sent;
              results = outputs.map(function (name) {
                return getTensor(name, _this7.tensorsMap, context);
              }); // dispose all the intermediate tensors
              outputIds = results.map(function (t) {
                return t.id;
              });
              inputIds = Object.keys(inputs).map(function (name) {
                return inputs[name].id;
              });
              this.keepIds = new Set([].concat(_toConsumableArray(outputIds), _toConsumableArray(inputIds), _toConsumableArray(this.weightIds)));
              if (!this.keepTensorForDebug) {
                this.disposeTensorsMap();
              }
              // dispose the context for the root executor
              if (this.parent == null) {
                context.dispose(this.keepIds);
              }
              return _context2.abrupt("return", results);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _executeAsync(_x3, _x4) {
        return _executeAsync3.apply(this, arguments);
      }
      return _executeAsync;
    }()
  }, {
    key: "executeFunctionAsync",
    value: function () {
      var _executeFunctionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(inputs, tensorArrayMap, tensorListMap) {
        var _this8 = this;
        var mappedInputs;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              mappedInputs = inputs.reduce(function (map, tensor, index) {
                map[_this8.inputs[index].name] = tensor;
                return map;
              }, {});
              return _context3.abrupt("return", this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function executeFunctionAsync(_x5, _x6, _x7) {
        return _executeFunctionAsync.apply(this, arguments);
      }
      return executeFunctionAsync;
    }()
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */
  }, {
    key: "executeWithControlFlow",
    value: function () {
      var _executeWithControlFlow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(inputs, context, outputNames, isFunctionExecution) {
        var _this9 = this;
        var names, inputNodes, outputNodeNames, outputNodes, _getExecutionSubgraph, usedNodes, missingInputs, dynamicNode, syncInputs, stack, tensorsMap, intermediateTensorConsumerCount, tensorsToKeep, added, promises, missingOutputs, alternativeMsg;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              names = Object.keys(inputs);
              inputNodes = names.map(function (name) {
                return _this9.graph.nodes[parseNodeName(name)[0]];
              });
              outputNodeNames = outputNames.map(function (name) {
                return parseNodeName(name)[0];
              });
              outputNodes = outputNodeNames.map(function (name) {
                return _this9.graph.nodes[name];
              }); // If no outputs are specified, then use the default outputs of the model.
              if (outputNodes.length === 0) {
                outputNodes = this._outputs;
              }
              _getExecutionSubgraph = getExecutionSubgraph(inputs, outputNodes, this.weightMap, this._initNodes), usedNodes = _getExecutionSubgraph.usedNodes, missingInputs = _getExecutionSubgraph.missingInputs, dynamicNode = _getExecutionSubgraph.dynamicNode, syncInputs = _getExecutionSubgraph.syncInputs; // First nodes to execute include inputNodes, weights, and initNodes.
              stack = [].concat(_toConsumableArray(inputNodes), _toConsumableArray(this.graph.weights), _toConsumableArray(this._initNodes || [])).map(function (node) {
                return {
                  node: node,
                  contexts: context.currentContext
                };
              });
              tensorsMap = Object.assign({}, this.weightMap);
              Object.keys(inputs).forEach(function (name) {
                var _parseNodeName3 = parseNodeName(name),
                  _parseNodeName4 = _slicedToArray(_parseNodeName3, 2),
                  nodeName = _parseNodeName4[0],
                  index = _parseNodeName4[1];
                var tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
              });
              intermediateTensorConsumerCount = {};
              tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
              added = {};
            case 12:
              if (!(stack.length > 0)) {
                _context4.next = 18;
                break;
              }
              promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount, usedNodes);
              _context4.next = 16;
              return Promise.all(promises);
            case 16:
              _context4.next = 12;
              break;
            case 18:
              if (dynamicNode == null && !isFunctionExecution) {
                console.warn("This model execution did not contain any nodes with control flow " + "or dynamic output shapes. You can use model.execute() instead.");
              }
              missingOutputs = outputNodes.filter(function (node) {
                return !isControlFlow(node) && !getTensor(node.name, tensorsMap, context);
              }).map(function (node) {
                return node.name;
              });
              if (!(missingOutputs.length > 0)) {
                _context4.next = 24;
                break;
              }
              alternativeMsg = '';
              if (dynamicNode != null) {
                alternativeMsg = "Alternatively, to avoid the dynamic ops, use model.execute() " + "and specify the inputs [".concat(syncInputs, "]");
              }
              throw new Error("Cannot compute the outputs [".concat(missingOutputs, "] from the provided ") + "inputs [".concat(names, "]. Consider providing the following inputs: ") + "[".concat(missingInputs, "]. ").concat(alternativeMsg));
            case 24:
              return _context4.abrupt("return", tensorsMap);
            case 25:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function executeWithControlFlow(_x8, _x9, _x10, _x11) {
        return _executeWithControlFlow.apply(this, arguments);
      }
      return executeWithControlFlow;
    }()
  }, {
    key: "processStack",
    value: function processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNames, intermediateTensorConsumerCount, usedNodes) {
      var _this10 = this;
      var promises = [];
      var _loop = function _loop() {
        var item = stack.pop();
        context.currentContext = item.contexts;
        var nodeName = '';
        // The tensor of the Enter op with isConstant set should be set
        // in the parent scope, so it will be available as constant for the
        // whole loop.
        if (item.node.op === 'Enter' && getParamValue('isConstant', item.node, tensorMap, context)) {
          var _getNodeNameAndIndex3 = getNodeNameAndIndex(item.node.name, context);
          var _getNodeNameAndIndex4 = _slicedToArray(_getNodeNameAndIndex3, 1);
          nodeName = _getNodeNameAndIndex4[0];
        }
        // only process nodes that are not in the tensorMap yet, this include
        // inputNodes and internal initNodes.
        if (tensorMap[item.node.name] == null) {
          var tensors = executeOp(item.node, tensorMap, context, _this10._resourceManager);
          if (!nodeName) {
            var _getNodeNameAndIndex5 = getNodeNameAndIndex(item.node.name, context);
            var _getNodeNameAndIndex6 = _slicedToArray(_getNodeNameAndIndex5, 1);
            nodeName = _getNodeNameAndIndex6[0];
          }
          var currentContext = context.currentContext;
          if (util.isPromise(tensors)) {
            promises.push(tensors.then(function (t) {
              tensorMap[nodeName] = t;
              context.currentContext = currentContext;
              _this10.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
              _this10.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
              return t;
            }));
          } else {
            tensorMap[nodeName] = tensors;
            _this10.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
            _this10.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
          }
        } else {
          _this10.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
      };
      while (stack.length > 0) {
        _loop();
      }
      return promises;
    }
  }, {
    key: "processChildNodes",
    value: function processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
      node.children.forEach(function (childNode) {
        var _getNodeNameAndIndex7 = getNodeNameAndIndex(childNode.name, context),
          _getNodeNameAndIndex8 = _slicedToArray(_getNodeNameAndIndex7, 1),
          nodeName = _getNodeNameAndIndex8[0];
        if (added[nodeName] || !usedNodes.has(childNode.name)) {
          return;
        }
        // Merge op can be pushed if any of its inputs has value.
        if (childNode.op === 'Merge') {
          if (childNode.inputNames.some(function (name) {
            return !!getTensor(name, tensorMap, context);
          })) {
            added[nodeName] = true;
            stack.push({
              contexts: context.currentContext,
              node: childNode
            });
          }
        } else
          // Otherwise all inputs must to have value.
          if (childNode.inputNames.every(function (name) {
            return !!getTensor(name, tensorMap, context);
          })) {
            added[nodeName] = true;
            stack.push({
              contexts: context.currentContext,
              node: childNode
            });
          }
      });
    }
    /**
     * Releases the memory used by the weight tensors.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      var _this11 = this;
      Object.keys(this.weightMap).forEach(function (key) {
        return _this11.weightMap[key].forEach(function (tensor) {
          return tensor.dispose();
        });
      });
    }
  }, {
    key: "checkInputShapeAndType",
    value: function checkInputShapeAndType(inputs) {
      var _this12 = this;
      Object.keys(inputs).forEach(function (name) {
        var input = inputs[name];
        var _parseNodeName5 = parseNodeName(name),
          _parseNodeName6 = _slicedToArray(_parseNodeName5, 1),
          nodeName = _parseNodeName6[0];
        var node = _this12.graph.nodes[nodeName];
        if (node.attrParams['shape'] && node.attrParams['shape'].value) {
          var shape = node.attrParams['shape'].value;
          var match = shape.length === input.shape.length && input.shape.every(function (dim, index) {
            return shape[index] === -1 || shape[index] === dim;
          });
          util.assert(match, function () {
            return "The shape of dict['".concat(node.name, "'] provided in ") + "model.execute(dict) must be [".concat(shape, "], but was ") + "[".concat(input.shape, "]");
          });
        }
        if (node.attrParams['dtype'] && node.attrParams['dtype'].value) {
          util.assert(input.dtype === node.attrParams['dtype'].value, function () {
            return "The dtype of dict['".concat(node.name, "'] provided in ") + "model.execute(dict) must be " + "".concat(node.attrParams['dtype'].value, ", but was ").concat(input.dtype);
          });
        }
      });
    }
  }, {
    key: "mapInputs",
    value: function mapInputs(inputs) {
      var result = {};
      for (var inputName in inputs) {
        if (this._signature != null && this._signature.inputs != null && this._signature.inputs[inputName] != null) {
          var tensor = this._signature.inputs[inputName];
          result[tensor.name] = inputs[inputName];
        } else {
          result[inputName] = inputs[inputName];
        }
      }
      return result;
    }
  }, {
    key: "checkInputs",
    value: function checkInputs(inputs) {
      var _this13 = this;
      var notInGraph = Object.keys(inputs).filter(function (name) {
        var _parseNodeName7 = parseNodeName(name),
          _parseNodeName8 = _slicedToArray(_parseNodeName7, 1),
          nodeName = _parseNodeName8[0];
        return _this13.graph.nodes[nodeName] == null;
      });
      if (notInGraph.length > 0) {
        throw new Error("The dict provided in model.execute(dict) has " + "keys: [".concat(notInGraph, "] that are not part of graph"));
      }
    }
  }, {
    key: "mapOutputs",
    value: function mapOutputs(outputs) {
      var _this14 = this;
      return outputs.map(function (name) {
        if (_this14._signature != null && _this14._signature.outputs != null && _this14._signature.outputs[name] != null) {
          var tensor = _this14._signature.outputs[name];
          return tensor.name;
        }
        return name;
      }, {});
    }
  }, {
    key: "checkOutputs",
    value: function checkOutputs(outputs) {
      var _this15 = this;
      outputs.forEach(function (name) {
        var _parseNodeName9 = parseNodeName(name),
          _parseNodeName10 = _slicedToArray(_parseNodeName9, 1),
          normalizedName = _parseNodeName10[0];
        if (!_this15.graph.nodes[normalizedName]) {
          throw new Error("The output '".concat(name, "' is not found in the graph"));
        }
      });
    }
  }]);
  return GraphExecutor;
}();